export const navigationMenu = {
  NEW: "new",
  PENDING: "pending",
  FINISHED: "finished"
};

export const permissionRole = {
  RJPADMIN: 20,
}


// WEBPACK FOOTER //
// ./src/components/other-web/lib/mapper.js